import { useTranslation } from 'react-i18next';

type DirectionResult = {
    isLTR: boolean;
    isRTL: boolean;
};
export const useDirection = (): DirectionResult => {
    const { i18n } = useTranslation();
    const isLTR = ['en', 'ru'].includes(i18n.language);
    const isRTL = !isLTR;

    return {
        isLTR,
        isRTL,
    };
};
